<div class="view-buttons">
    <button mat-fab aria-label="Edit Model Button" class="data-view-action" [class.data-view-action--selected]="currentTabType === TabType.MODEL_CREATOR" matTooltip="Go to Edit Model" matTooltipPosition="above" (click)="changeTabType(TabType.MODEL_CREATOR)">
        <mat-icon>edit</mat-icon>
    </button>

    <button mat-fab class="ms-3 data-view-action" aria-label="Simulation Button" [class.data-view-action--selected]="currentTabType === TabType.SIMULATION" matTooltip="Go to Simulation" matTooltipPosition="above"
        (click)="changeTabType(TabType.SIMULATION)">
        <span class="material-symbols-outlined d-flex justify-content-center align-items-center">route</span>
    </button>

    @if (dataViewer.savedDocument) {
        @if (dataViewer.showMetricsButton) {
            <button mat-fab class="ms-3 data-view-action" aria-label="Metrics Button" [class.data-view-action--selected]="currentTabType === TabType.METRICS" matTooltip="Go to Model Metrics" matTooltipPosition="above" (click)="changeTabType(TabType.METRICS)">
                <span class="material-symbols-outlined">
                    view_timeline
                </span>
            </button>
        }
    }
</div>
